/**
 * @owner @Appboy/ingestion
 */

import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { appsTransformationsCacheKey } from "./constants";
import type { GetTransformationPayload } from "./types";

export const getTransformation = reactQueryFetcherAdapter(
  appsTransformationsCacheKey,
  async (): Promise<GetTransformationPayload> => {
    return fetch(
      appsTransformationsCacheKey,
      "GET",
      {},
      {},
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
